"use client";

import type { Locale } from "@i18n/react";
import { useLocale } from "@i18n/react";
import { HallowABFlag, useMixpanel } from "@packages/ab";
import { useRequestMe } from "@packages/sdk";
import { useMemo } from "react";

import { isValidKidsLocale } from "../lib/utils/isValidKidsLocale";
import { useRequestMeRelatedAccounts } from "../requests/useRequestMeRelatedAccounts";

export const useIsKidsProfilesVisible = (): boolean => {
  const { query: meQuery } = useRequestMe();
  const { data: meRelatedAccounts } = useRequestMeRelatedAccounts();
  const { flags } = useMixpanel();
  const locale = useLocale();

  return useMemo(() => {
    // only show kids profiles to kids if they have a parent
    if (
      (meQuery.data?.is_kid && meRelatedAccounts?.length > 1) ||
      meQuery.data?.has_parent_pin
    )
      return true;

    if (meQuery.data?.is_kid) return false;

    if (!flags?.[HallowABFlag.WebKidsProfileLaunch]?.isTargeted) return false;

    return (
      isValidKidsLocale(locale as Locale) && meQuery.data?.country === "US"
    );
  }, [
    meQuery.data?.is_kid,
    meRelatedAccounts?.length,
    meQuery.data?.has_parent_pin,
    flags?.[HallowABFlag.WebKidsProfileLaunch]?.isTargeted,
    meQuery.data?.country,
    locale,
  ]);
};
